/* global VXConfig */
import React                       from 'react';
import PropTypes                   from 'prop-types';
import Translations                from '../../../utils/Translations';
import MediaPin                    from '../../Favorite/Actor/MediaPin';
import AlbumDescriptionButtonsItem from './AlbumDescriptionButtonsItem';
import {dislikeMedia, likeMedia}   from '../../ActorMediaVotingActions';
import withGalleryComments         from '../../HigherOrderComponents/ActorProfileVideos/withGalleryComments';
import withGalleryRatings          from '../../HigherOrderComponents/ActorProfileVideos/withGalleryRatings';
import compose                     from '../../HigherOrderComponents/compose';
import AlbumDescriptionLikeButton  from './AlbumDescriptionLikeButton';
import Flux                        from '../../../flux/Flux';
import ContestVoting               from '../../ContestVoting.js';
import Constants from '../../../flux/Constants';


class AlbumDescriptionButtons extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            album: this.props.album,
        };

        this.onLikeClick       = this.onLikeClick.bind(this);
        this.onDislikeClick    = this.onDislikeClick.bind(this);
        this.onGalleryChange   = this.onGalleryChange.bind(this);
        this.onVoteChange      = this.onVoteChange.bind(this);
    }

    componentDidMount() {
        Flux.Gallery.addGalleryChangeListener(this.onGalleryChange);
        Flux.Contest.addContestVotingChangeListener(this.onVoteChange);

        if(this.props.album.contest) {
            let guestData = Flux.Contest.getGuestData(this.props.album.contest.contestId, Flux.Constants.ContestSubTypes.ACTOR);
            if (!guestData && this.props.album?.contest?.isActive) {
                Flux.Contest.loadGuestData(this.props.album.contest.contestId, Flux.Constants.ContestSubTypes.ACTOR);
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.album !== this.props.album) {
            const album           = this.props.album;
            album.isBought        = this.state.album.isBought;
            album.isVotingVisible = this.state.album.isVotingVisible;
            this.setState({album});
        }
    }

    componentWillUnmount() {
        Flux.Gallery.removeGalleryChangeListener(this.onGalleryChange);
        Flux.Contest.removeContestVotingChangeListener(this.onVoteChange);
    }

    onGalleryChange(actorId, albumId) {
        if (albumId === this.state.album.id) {
            const album = Flux.Gallery.getGalleryData(albumId);
            if (!this.state.album.isBought) {
                this.setState({album});
            }
        }
    }

    onLikeClick() {
        likeMedia(this.props.actor.id, this.props.album.id);
    }

    onDislikeClick() {
        dislikeMedia(this.props.actor.id, this.props.album.id);
    }

    onVoteChange() {
        this.setState((prevState) => ({
            album: {
                ...prevState.album,
                contest: {
                    ...prevState.album.contest,
                    hasVoted: true,
                    votes:    prevState.album.contest.votes + 1,
                },
            },
        }));
    }


    getVoteButtons(isInActiveContest) {
        if (isInActiveContest) {
            return (<>
                    <ContestVoting
                            contestId={this.state.album.contest.contestId}
                            actorId={this.props.actor.id}
                            actorName={this.props.actor.name}
                            mediaId={VXConfig.isVXMobilePlatform ? this.state.album.video.videoId : this.state.album.videoId}
                            guestId={Flux.Guest.getId()}
                            isVoted={this.state.album.contest.hasVoted}
                            albumId={VXConfig.isVXMobilePlatform ? this.state.album.id : this.state.album.albumId}
                            isVotingAllowed={this.state.album.isVotingVisible}
                            contestArea={Flux.Constants.ContestSubTypes.ACTOR}
                            styleClass={this.props.baseClassName + "-el profile-video-details--contest-votes"}
                            contestName={this.state.album.contest.contestId}
                            count={this.state.album.contest.votes}
                            tooltipText={Translations.get('contests.voting-hover')}
                    />
            </>);
        } else {
            return (this.props.showLikeBeforeBuy && <>
				<AlbumDescriptionLikeButton baseClassName={this.props.baseClassName}
				                             text={this.state.album.likes !== undefined ? this.state.album.likes : this.state.album.guestRatingLikes}
				                             checked={this.state.album.isLiked}
				                             onClick={this.onLikeClick}
                                             tooltipPosition={this.props.isVideoDetailPage ? Constants.Tooltip.place.BottomStart : null}
                                             showLikeBeforeBuy={this.props.showLikeBeforeBuy}
                                             isVotingVisible={this.props.showLikeBeforeBuy}
                                             isBought={this.state.album.isBought}
				/>
                <AlbumDescriptionButtonsItem baseClassName={this.props.baseClassName}
				                             icon="-icon-unlike-line"
				                             iconChecked="-icon-unlike-full"
				                             text={this.state.album.dislikes !== undefined ? this.state.album.dislikes : this.state.album.guestRatingDislikes}
				                             tooltipText={Translations.get('DislikeTooltip')}
				                             checked={this.state.album.isDisliked}
				                             onClick={this.onDislikeClick}
				                             checkable={false}
                                             tooltipPosition={this.props.isVideoDetailPage ? Constants.Tooltip.place.BottomStart : null}
                                             showLikeBeforeBuy={this.props.showLikeBeforeBuy}
                                             isVotingVisible={this.props.showLikeBeforeBuy}
                                             isBought={this.state.album.isBought}
				/>
            </>);
        }
    }

    render() {
        const {album}                                                                                               = this.state;
        const {actor, baseClassName, showSocialShare}                                                               = this.props;
        const {areCommentsVisible, isVotingVisible, isAllowedToCommentAlbum, guestRatingLikes, guestRatingDislikes} = album;

        let isInActiveContest = album.contest?.isActive;

        return (
                <div className={baseClassName + (!isVotingVisible && isInActiveContest ? ' jf-right' : '')}>
                    {(Flux.Guest.isLoggedIn() && isVotingVisible  || this.props.showLikeBeforeBuy) && this.getVoteButtons(isInActiveContest)}

                    {isVotingVisible && (areCommentsVisible || isAllowedToCommentAlbum) && this.props.isCommented &&
                    <AlbumDescriptionButtonsItem baseClassName={baseClassName}
                                                icon="-icon-chat-flat-line"
                                                iconChecked="-icon-chat-flat"
                                                text={this.props.commentsTotalCount}
                                                tooltipText={Translations.get('CommentTooltip')}
                                                checked={this.props.isCommented}
                                                onClick={this.props.onCommentsClick}
                                                checkable={false}
                    />}
                    <MediaPin actorId={actor.id}
                            albumId={album.id}
                            initialIsFavorite={!!(album.isFavoriteAlbum || album.isFavorite || album.pinned)}
                            fontSize=""
                            tooltipPlacement="top"
                    />
                    {showSocialShare &&
                    <AlbumDescriptionButtonsItem baseClassName={baseClassName}
                                                icon="-icon-share-icon-line"
                                                iconChecked="-icon-share-icon"
                                                tooltipText={Translations.get('ShareTooltip')}
                                                onClick={this.props.onShareClick}
                    />}
			    </div>
		);
	}
}

AlbumDescriptionButtons.propTypes = {
    album:           PropTypes.shape({
        id:                      PropTypes.number,
        description:             PropTypes.string,
        contestPlace:            PropTypes.number,
        releaseDate:             PropTypes.string,
        duration:                PropTypes.string,
        hasAudio:                PropTypes.bool,
        totalViews:              PropTypes.number,
        title:                   PropTypes.string,
        contestDetailsUrl:       PropTypes.string,
        likes:                   PropTypes.number,
        dislikes:                PropTypes.number,
        isLiked:                 PropTypes.bool,
        isDisliked:              PropTypes.bool,
        isFavoriteAlbum:         PropTypes.bool,
        isFavorite:              PropTypes.bool,
        isVotingVisible:         PropTypes.bool,
        areCommentsVisible:      PropTypes.bool,
        isAllowedToCommentAlbum: PropTypes.bool,
        guestRatingLikes:        PropTypes.number,
        guestRatingDislikes:     PropTypes.number,
        pinned:                  PropTypes.bool,
        isBought:                PropTypes.bool,
        contest:                 PropTypes.shape({
            contestId:   PropTypes.number,
            contestLink: PropTypes.string,
            guestData:   PropTypes.shape({
                hideVoteLimitModal: PropTypes.bool,
                voteLimit:          PropTypes.number,
                voteCount:          PropTypes.number,
            }),
            hasVoted:    PropTypes.bool,
            isActive:    PropTypes.bool,
        }),
    }),
    actor:           PropTypes.shape({
        id:   PropTypes.number,
        name: PropTypes.string,
    }),
    baseClassName:   PropTypes.string,
    onShareClick:    PropTypes.func,
    onCommentsClick: PropTypes.func,
    // from withGalleryComments
    commentsTotalCount: PropTypes.number,
    isCommented:        PropTypes.bool,
    showSocialShare:    PropTypes.bool,
    isVideoDetailPage:  PropTypes.bool,
    showLikeBeforeBuy:  PropTypes.bool,
};

AlbumDescriptionButtons.defaultProps = {
    baseClassName:   '',
	onShareClick:    () => {
	},
	onCommentsClick: () => {
	},
	showSocialShare: false,
    isVideoDetailPage: false,
    showLikeBeforeBuy: false,
};


export default compose(withGalleryComments, withGalleryRatings)(AlbumDescriptionButtons);














